export function buildDashboardYearBlockFromTerritories(territories) {
  const safeTerritories = Array.isArray(territories) ? territories : [];

  if (safeTerritories.length > 1) {
    const allDates = Array.from(
      new Set(
        safeTerritories.flatMap(t => (t.dailyData || []).map(d => d.date))
      )
    ).sort();

    const dailyData = allDates.map(date => {
      const recs = safeTerritories
        .map(t => (t.dailyData || []).find(d => d.date === date))
        .filter(Boolean);

      const totals = recs.reduce(
        (acc, r) => {
          acc.totalOrders += Number(r.totalOrders || 0);
          acc.totalRevenue += Number(r.totalRevenue || 0);
          acc.totalCases += Number(r.totalCases || 0);
          acc.totalUnits += Number(r.totalUnits || 0);
          return acc;
        },
        { totalOrders: 0, totalRevenue: 0, totalCases: 0, totalUnits: 0 }
      );

      const combinedBrands = recs.reduce((acc, r) => {
        Object.entries(r.brands || {}).forEach(([brand, info]) => {
          if (!acc[brand]) acc[brand] = { orders: 0, revenue: 0, cases: 0 };
          acc[brand].orders += Number(info.orders || 0);
          acc[brand].revenue += Number(info.revenue || 0);
          acc[brand].cases += Number(info.cases || 0);
        });
        return acc;
      }, {});

      const combinedCategories = recs.reduce((acc, r) => {
        Object.entries(r.categories || {}).forEach(([cat, ci]) => {
          if (!acc[cat]) acc[cat] = { orders: 0, revenue: 0, cases: 0, brands: {} };
          acc[cat].orders += Number(ci.orders || 0);
          acc[cat].revenue += Number(ci.revenue || 0);
          acc[cat].cases += Number(ci.cases || 0);
          Object.entries(ci.brands || {}).forEach(([b, bi]) => {
            if (!acc[cat].brands[b]) acc[cat].brands[b] = { orders: 0, revenue: 0, cases: 0 };
            acc[cat].brands[b].orders += Number(bi.orders || 0);
            acc[cat].brands[b].revenue += Number(bi.revenue || 0);
            acc[cat].brands[b].cases += Number(bi.cases || 0);
          });
        });
        return acc;
      }, {});

      return { date, ...totals, brands: combinedBrands, categories: combinedCategories };
    });

    return { territories: safeTerritories, dailyData };
  }

  return {
    territories: safeTerritories,
    dailyData: safeTerritories[0]?.dailyData || [],
  };
}

